/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * @format int32
 */
export type Type3W = 0 | 1 | 2 | 3;

export interface DateRange {
  /** @format date-time */
  start: string | null;

  /** @format date-time */
  end: string | null;
}

/**
 * @format int32
 */
export type ClientImpact = 1 | 2 | 3;

export interface ClientNoteFilter {
  assignedToMe: boolean | null;
  impact: ClientImpact | null;
  ratings: number[] | null;
}

/**
 * @format int32
 */
export type PwcImpact = 0 | 1 | 2 | 3;

export interface PwcNoteFilter {
  impact: PwcImpact | null;
  ratings: number[] | null;
}

export interface Article3WFilter {
  ids: string[] | null;
  type: Type3W | null;
  territories: string[] | null;
  issuers: string[] | null;
  topics: string[] | null;
  documentTypes: string[] | null;
  published: boolean | null;
  publishDateRange: DateRange | null;
  linkedNewsDateRange: DateRange | null;
  freeTextSearch: string | null;

  /** @format int32 */
  businessId: number | null;
  checkedEventDates: boolean | null;
  clientNoteFilter: ClientNoteFilter | null;
  pwcNoteFilter: PwcNoteFilter | null;
}

export interface OrderBy {
  isDescending: boolean | null;
}

export interface Article3WOrderBy {
  publishDate: OrderBy | null;
  creationDate: OrderBy | null;
}

export interface Article3WQueryDTO {
  filters: Article3WFilter | null;
  orderBy: Article3WOrderBy | null;
}

export interface Article3WReadDTO {
  /** @format uuid */
  id: string;
  type: Type3W;
  published: boolean;
  title: string | null;
  description: Record<string, string>;

  /** @format int32 */
  businessId: number;

  /** @format date-time */
  creationDate: string;

  /** @format date-time */
  lastUpdateDate: string;

  /** @format date-time */
  publishDate: string;

  /** @format uuid */
  territoryId: string | null;
  issuerIds: string[] | null;
  topicIds: string[] | null;
  documentTypeIds: string[] | null;
  checkedEventDates: boolean;
  reviewed: boolean;
}

export interface Article3WUpdateDTO {
  title: string | null;
  description: Record<string, string>;

  /** @format int32 */
  businessId: number;

  /** @format date-time */
  publishDate: string;

  /** @format uuid */
  territoryId: string | null;
  published: boolean;
  issuerIds: string[] | null;
  topicIds: string[] | null;
  documentTypeIds: string[] | null;
  checkedEventDates: boolean;
  reviewed: boolean;
}

export interface Article3WCreateDTO {
  type: Type3W | null;
  published: boolean;
  title: string | null;
  description: Record<string, string>;

  /** @format int32 */
  businessId: number;

  /** @format date-time */
  publishDate: string;

  /** @format uuid */
  territoryId: string | null;
  issuerIds: string[] | null;
  topicIds: string[] | null;
  documentTypeIds: string[] | null;
  checkedEventDates: boolean;
  reviewed: boolean;
}

export interface ClientNoteReadDTO {
  /** @format uuid */
  sourceId: string;

  /** @format uuid */
  subscriptionId: string;
  isMainContact: boolean;
  impact: ClientImpact;

  /** @format int32 */
  rating: number;
  assignedTo: string[] | null;
  generalComments: string | null;
  personalComments: string | null;
}

export interface ClientNoteUpdateAllDTO {
  impact: ClientImpact;

  /** @format int32 */
  rating: number;
  assignedTo: string[] | null;
  generalComments: string | null;
  personalComments: string | null;
}

export interface ClientNoteUpdatePersonalDTO {
  assignedToMe: boolean;
  personalComments: string | null;
}

export interface PwcNoteReadDTO {
  /** @format uuid */
  sourceId: string;

  /** @format uuid */
  subscriptionId: string;
  companyName: string | null;
  impact: PwcImpact;

  /** @format int32 */
  rating: number;
  reviewed: boolean;
  comment: string | null;
  groupRating: string | null;

  /** @format int32 */
  orderRating: number | null;
  isMultiRating: boolean;
  ratingTitle: string | null;
  subscriptionRatingTitle: string | null;

  /** @format uuid */
  multiRatingItemId: string | null;
}

export interface PwcNoteUpdateDTO {
  /** @format uuid */
  subscriptionId: string;
  impact: PwcImpact;

  /** @format int32 */
  rating: number;
  reviewed: boolean;
  comment: string | null;

  /** @format uuid */
  multiRatingItemId: string | null;
}

export interface Article3WTitleReadDTO {
  /** @format uuid */
  id: string;
  value: string | null;
}

export interface DashboardFilter {
  type: Type3W | null;
  freeTextSearch: string | null;
  pendingArticle: boolean | null;
  topics: string[] | null;
  territories: string[] | null;
  issuers: string[] | null;
  documentTypes: string[] | null;
  sourceDateRange: DateRange | null;
}

export interface NewsReadDTO {
  /** @format uuid */
  id: string;
  type: Type3W;
  published: boolean;
  title: string | null;
  href: string | null;
  mustRead: boolean;
  repositoryItem: boolean;
  repositoryText: string | null;

  /** @format date-time */
  creationDate: string;

  /** @format date-time */
  lastUpdateDate: string;

  /** @format date-time */
  issueDate: string;

  /** @format date-time */
  publishedDate: string | null;

  /** @format uuid */
  articleId: string | null;

  /** @format uuid */
  territoryId: string | null;

  /** @format uuid */
  documentTypeId: string | null;
  issuerIds: string[] | null;
  topicIds: string[] | null;
  isAlive: boolean;

  /** @format date-time */
  checkedDate: string | null;
}

export interface PublicationReadDTO {
  /** @format uuid */
  id: string;
  published: boolean;
  type: Type3W;
  title: string | null;
  description: string | null;
  fileUrl: string | null;

  /** @format date-time */
  creationDate: string;

  /** @format date-time */
  lastUpdateDate: string;

  /** @format date-time */
  issueDate: string;

  /** @format uuid */
  territoryId: string | null;
  issuerIds: string[] | null;
  topicIds: string[] | null;

  /** @format date-time */
  publishedDate: string | null;
}

export interface VideoReadDTO {
  /** @format uuid */
  id: string;
  published: boolean;
  type: Type3W;
  hyperlink: string | null;
  title: string | null;
  description: string | null;

  /** @format uuid */
  territoryId: string | null;
  topicIds: string[] | null;

  /** @format date-time */
  creationDate: string;

  /** @format date-time */
  lastUpdateDate: string;

  /** @format date-time */
  issueDate: string;

  /** @format date-time */
  publishedDate: string | null;
}

export interface DashboardDTO {
  articles: Article3WReadDTO[] | null;
  news: NewsReadDTO[] | null;
  publication: PublicationReadDTO[] | null;
  video: VideoReadDTO[] | null;
}

export interface DocumentTypeReadDTO {
  /** @format uuid */
  id: string;
  name: string | null;
  description: string | null;
}

export interface DocumentTypeUpdateDTO {
  name: string | null;
  description: string | null;
}

export interface DocumentTypeCreateDTO {
  name: string | null;
  description: string | null;
}

export interface AmdsEventFilter {
  type: Type3W | null;
  territories: string[] | null;
  issuers: string[] | null;
  topics: string[] | null;
  documentTypes: string[] | null;
  published: boolean | null;
  startDateRange: DateRange | null;
  freeTextSearch: string | null;
}

export interface AmdsEventOrderBy {
  startDate: OrderBy | null;
  creationDate: OrderBy | null;
}

export interface AmdsEventQueryDTO {
  filters: AmdsEventFilter | null;
  orderBy: AmdsEventOrderBy | null;
}

export interface AmdsEventReadDTO {
  /** @format uuid */
  id: string;
  published: boolean;
  title: string | null;
  description: string | null;

  /** @format date-time */
  creationDate: string;

  /** @format date-time */
  lastUpdateDate: string;

  /** @format date-time */
  startDate: string;

  /** @format uuid */
  territoryId: string;
  type: Type3W;

  /** @format uuid */
  articleId: string | null;
  topicIds: string[] | null;
}

export interface AmdsEventUpdateDTO {
  title: string | null;
  description: string | null;

  /** @format date-time */
  startDate: string;

  /** @format uuid */
  territoryId: string;

  /** @format uuid */
  articleId: string | null;
  topicIds: string[] | null;
}

export interface AmdsEventCreateDTO {
  published: boolean;
  title: string | null;
  description: string | null;

  /** @format date-time */
  startDate: string;

  /** @format uuid */
  territoryId: string;
  type: Type3W | null;

  /** @format uuid */
  articleId: string | null;
  topicIds: string[] | null;
}

export interface ExportFilter {
  type: Type3W | null;
  territories: string[] | null;
  issuers: string[] | null;
  topics: string[] | null;
  documentTypes: string[] | null;
  published: boolean | null;
  mustRead: boolean | null;
  issuedDateRange: DateRange | null;
  publishedDateRange: DateRange | null;
  freeTextSearch: string | null;

  /** @format uuid */
  exportAsSubscriptionId: string | null;
  withExtendedInfos: boolean;
}

export interface NewsFilter {
  type: Type3W | null;
  territories: string[] | null;
  issuers: string[] | null;
  topics: string[] | null;
  documentTypes: string[] | null;
  published: boolean | null;
  mustRead: boolean | null;
  repositoryItem: boolean | null;
  isAlive: boolean | null;
  issuedDateRange: DateRange | null;
  freeTextSearch: string | null;
  publishedDateRange: DateRange | null;
}

export interface IssuerReadDTO {
  /** @format uuid */
  id: string;
  name: string | null;
  description: string | null;
}

export interface IssuerCreateDTO {
  name: string | null;
  description: string | null;
}

export interface IssuerUpdateDTO {
  name: string | null;
  description: string | null;
}

export interface TypeAccess {
  canRead: boolean;
  canWrite: boolean;
  canDelete: boolean;
  trial: boolean;

  /** @format date-time */
  endDate: string | null;
}

export interface TypeAccesses {
  access: Record<string, TypeAccess>;
}

export interface TopicReadLightDTO {
  /** @format uuid */
  id: string;
  name: string | null;
  category: string | null;
}

export interface TerritoryReadDTO {
  /** @format uuid */
  id: string;
  name: string | null;
  group: string | null;
  alpha2Code: string | null;
  alpha3Code: string | null;
  region: string | null;
  subregion: string | null;
}

export interface MetadataDTO {
  documentTypes: DocumentTypeReadDTO[] | null;
  topics: TopicReadLightDTO[] | null;
  issuers: IssuerReadDTO[] | null;
  territories: TerritoryReadDTO[] | null;
}

export interface NewsOrderBy {
  issueDate: OrderBy | null;
  creationDate: OrderBy | null;
  publishedDate: OrderBy | null;
}

export interface NewsQueryDTO {
  filters: NewsFilter | null;
  orderBy: NewsOrderBy | null;
}

export interface NewsUpdateDTO {
  title: string | null;
  href: string | null;
  mustRead: boolean | null;
  repositoryItem: boolean;
  repositoryText: string | null;

  /** @format date-time */
  issueDate: string;

  /** @format uuid */
  territoryId: string | null;
  issuerIds: string[] | null;

  /** @format uuid */
  documentTypeId: string | null;
  topicIds: string[] | null;
}

export interface NewsTitleReadDTO {
  /** @format uuid */
  id: string;
  value: string | null;
}

export interface NewsCreateDTO {
  type: Type3W | null;
  published: boolean;
  title: string | null;
  href: string | null;
  mustRead: boolean | null;
  repositoryItem: boolean;
  repositoryText: string | null;

  /** @format date-time */
  issueDate: string;

  /** @format uuid */
  articleId: string | null;

  /** @format uuid */
  territoryId: string | null;
  issuerIds: string[] | null;

  /** @format uuid */
  documentTypeId: string | null;
  topicIds: string[] | null;
}

export interface NewsUpdateArticleIdDTO {
  ids: string[] | null;

  /** @format uuid */
  articleId: string | null;
}

export interface PublicationFilter {
  type: Type3W | null;
  territories: string[] | null;
  issuers: string[] | null;
  topics: string[] | null;
  documentTypes: string[] | null;
  published: boolean | null;
  freeTextSearch: string | null;
  issueDate: DateRange | null;
}

export interface PublicationOrderBy {
  creationDate: OrderBy | null;
  lastUpdateDate: OrderBy | null;
  issueDate: OrderBy | null;
}

export interface PublicationQueryDTO {
  filters: PublicationFilter | null;
  orderBy: PublicationOrderBy | null;
}

export interface MultiRatingItem {
  /** @format uuid */
  id: string;
  subscriptionRatingTitle: string | null;
  ratingTitle: string | null;
  group: string | null;

  /** @format int32 */
  order: number;
}

export interface SubscriptionAccessReadDTO {
  /** @format uuid */
  subscriptionId: string;
  territoryIds: string[] | null;
  topicIds: string[] | null;
  deniedTopicIds: string[] | null;
  documentTypeIds: string[] | null;
  deniedDocumentTypeIds: string[] | null;
  groupRating: string | null;

  /** @format int32 */
  orderRating: number;
  hasMultiRating: boolean;
  multiRatings: MultiRatingItem[] | null;
}

export interface MultiRatingItemDTO {
  /** @format uuid */
  id: string | null;
  subscriptionRatingTitle: string | null;
  ratingTitle: string | null;
  group: string | null;

  /** @format int32 */
  order: number;
}

export interface SubscriptionAccessUpdateDTO {
  territoryIds: string[] | null;
  topicIds: string[] | null;
  deniedTopicIds: string[] | null;
  documentTypeIds: string[] | null;
  deniedDocumentTypeIds: string[] | null;
  hasMultiRating: boolean;
  groupRating: string | null;

  /** @format int32 */
  orderRating: number;
  multiRatings: MultiRatingItemDTO[] | null;
}

export interface SubscriptionAccessLightReadDTO {
  /** @format uuid */
  companyId: string;
  companyName: string | null;

  /** @format uuid */
  entityId: string;
  entityName: string | null;

  /** @format uuid */
  subscriptionId: string;

  /** @format uuid */
  multiRatingItemId: string | null;
  subscriptionRatingTitle: string | null;
  ratingTitle: string | null;
}

export interface TopicReadDTO {
  /** @format uuid */
  id: string;
  name: string | null;
  category: string | null;
  comments: string | null;
  internalComments: string | null;
  territory: string | null;
  issuer: string | null;

  /** @format date-time */
  publicationDate: string | null;
  documentType: string | null;
  hyperlink: string | null;
  modules: Type3W[] | null;
}

export interface TopicUpdateDTO {
  name: string | null;
  category: string | null;
  comments: string | null;
  internalComments: string | null;
  territory: string | null;
  issuer: string | null;

  /** @format date-time */
  publicationDate: string | null;
  documentType: string | null;
  hyperlink: string | null;
  modules: Type3W[] | null;
}

export interface TopicCreateDTO {
  name: string | null;
  category: string | null;
  comments: string | null;
  internalComments: string | null;
  territory: string | null;
  issuer: string | null;

  /** @format date-time */
  publicationDate: string | null;
  documentType: string | null;
  hyperlink: string | null;
  modules: Type3W[] | null;
}

export interface VideoFilter {
  type: Type3W | null;
  territories: string[] | null;
  topics: string[] | null;
  documentTypes: string[] | null;
  published: boolean | null;
  issueDate: DateRange | null;
  freeTextSearch: string | null;
}

export interface VideoOrderBy {
  creationDate: OrderBy | null;
  lastUpdateDate: OrderBy | null;
  issueDate: OrderBy | null;
}

export interface VideoQueryDTO {
  filters: VideoFilter | null;
  orderBy: VideoOrderBy | null;
}

export interface VideoUpdateDTO {
  hyperlink: string | null;
  title: string | null;
  description: string | null;

  /** @format uuid */
  territoryId: string | null;

  /** @format date-time */
  issueDate: string;
  topicIds: string[] | null;
}

export interface VideoCreateDTO {
  published: boolean;
  type: Type3W | null;
  hyperlink: string | null;
  title: string | null;
  description: string | null;

  /** @format uuid */
  territoryId: string | null;

  /** @format date-time */
  issueDate: string;
  topicIds: string[] | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title News Services v1
 * @version v1
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags AccessRequest
     * @name V1AccessRequestCreate
     * @summary Send the access request to the dedicated team.
     * @request POST:/api/v1/AccessRequest/{type}
     * @secure
     */
    v1AccessRequestCreate: (type: Type3W, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/AccessRequest/${type}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WPagedCreate
     * @summary Return all filtered articles in a paged result.
     * @request POST:/api/v1/Article3W/paged
     * @secure
     */
    v1Article3WPagedCreate: (
      query: { pageNumber: number; pageSize: number },
      data: Article3WQueryDTO,
      params: RequestParams = {}
    ) =>
      this.request<Article3WReadDTO[], any>({
        path: `/api/v1/Article3W/paged`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WDetail
     * @summary Return the specified article.
     * @request GET:/api/v1/Article3W/{id}
     * @secure
     */
    v1Article3WDetail: (id: string, params: RequestParams = {}) =>
      this.request<Article3WReadDTO, any>({
        path: `/api/v1/Article3W/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WUpdate
     * @summary Update the specified article.
     * @request PUT:/api/v1/Article3W/{id}
     * @secure
     */
    v1Article3WUpdate: (id: string, data: Article3WUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WDelete
     * @summary Delete the specified article/subarticle.
     * @request DELETE:/api/v1/Article3W/{id}
     * @secure
     */
    v1Article3WDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WNextBusinessIdDetail
     * @summary Return the next Id (auto-incremented) for the 3W articles.
     * @request GET:/api/v1/Article3W/nextBusinessId/{type}
     * @secure
     */
    v1Article3WNextBusinessIdDetail: (type: Type3W, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/api/v1/Article3W/nextBusinessId/${type}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WCreate
     * @summary Create the specified article.
     * @request POST:/api/v1/Article3W
     * @secure
     */
    v1Article3WCreate: (data: Article3WCreateDTO, params: RequestParams = {}) =>
      this.request<Article3WReadDTO, any>({
        path: `/api/v1/Article3W`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WImportList
     * @summary Download the template for the import.
     * @request GET:/api/v1/Article3W/import
     * @secure
     */
    v1Article3WImportList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/import`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WImportCreate
     * @summary Import articles from Excel file.
     * @request POST:/api/v1/Article3W/import
     * @secure
     */
    v1Article3WImportCreate: (data: { importFile?: File }, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WPublishPartialUpdate
     * @summary Update the publish state of the article.
     * @request PATCH:/api/v1/Article3W/{id}/publish
     * @secure
     */
    v1Article3WPublishPartialUpdate: (id: string, data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/${id}/publish`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WClientNoteDetail
     * @summary Return the client note corresponding to article and current user.
     * @request GET:/api/v1/Article3W/{id}/ClientNote
     * @secure
     */
    v1Article3WClientNoteDetail: (id: string, params: RequestParams = {}) =>
      this.request<ClientNoteReadDTO, any>({
        path: `/api/v1/Article3W/${id}/ClientNote`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WClientNoteUpdate
     * @summary Update the client note corresponding to article and current user.
     * @request PUT:/api/v1/Article3W/{id}/ClientNote
     * @secure
     */
    v1Article3WClientNoteUpdate: (id: string, data: ClientNoteUpdateAllDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/${id}/ClientNote`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WClientNoteDetail2
     * @summary Return the client note corresponding to article and subscription.
     * @request GET:/api/v1/Article3W/{id}/ClientNote/{subscriptionId}
     * @originalName v1Article3WClientNoteDetail
     * @duplicate
     * @secure
     */
    v1Article3WClientNoteDetail2: (id: string, subscriptionId: string, params: RequestParams = {}) =>
      this.request<ClientNoteReadDTO, any>({
        path: `/api/v1/Article3W/${id}/ClientNote/${subscriptionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WClientNotePersonalUpdate
     * @summary Update the client note corresponding to article and current user.
     * @request PUT:/api/v1/Article3W/{id}/ClientNote/Personal
     * @secure
     */
    v1Article3WClientNotePersonalUpdate: (id: string, data: ClientNoteUpdatePersonalDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/${id}/ClientNote/Personal`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WPwCNoteDetail
     * @summary Return the PwC note corresponding to article and current user.
     * @request GET:/api/v1/Article3W/{id}/PwCNote
     * @secure
     */
    v1Article3WPwCNoteDetail: (id: string, params: RequestParams = {}) =>
      this.request<PwcNoteReadDTO, any>({
        path: `/api/v1/Article3W/${id}/PwCNote`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WPwCNoteUpdate
     * @summary Update the PwC note corresponding to article and all companies.
     * @request PUT:/api/v1/Article3W/{id}/PwCNote
     * @secure
     */
    v1Article3WPwCNoteUpdate: (id: string, data: PwcNoteUpdateDTO[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Article3W/${id}/PwCNote`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WPwCNoteAllDetail
     * @summary Return the PwC note corresponding to article for all companies.
     * @request GET:/api/v1/Article3W/{id}/PwCNote/All
     * @secure
     */
    v1Article3WPwCNoteAllDetail: (id: string, params: RequestParams = {}) =>
      this.request<PwcNoteReadDTO[], any>({
        path: `/api/v1/Article3W/${id}/PwCNote/All`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WTitlesCreate
     * @summary Return the specified titles of article list.
     * @request POST:/api/v1/Article3W/titles
     * @secure
     */
    v1Article3WTitlesCreate: (data: string[], params: RequestParams = {}) =>
      this.request<Article3WTitleReadDTO[], any>({
        path: `/api/v1/Article3W/titles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3W
     * @name V1Article3WImpactDetail
     * @summary Return the impact and rating of an article.
     * @request GET:/api/v1/Article3W/impact/{subscriptionId}/{articleType}/{businessId}
     * @secure
     */
    v1Article3WImpactDetail: (
      articleType: Type3W,
      businessId: number,
      subscriptionId: string,
      params: RequestParams = {}
    ) =>
      this.request<PwcNoteReadDTO, any>({
        path: `/api/v1/Article3W/impact/${subscriptionId}/${articleType}/${businessId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Article3WIntegration
     * @name V1IntegrationArticle3WGetPublishedFromList
     * @summary Return the article published with a publication date equal or greater than the one specified.
     * @request GET:/api/v1/Integration/Article3W/GetPublishedFrom
     * @secure
     */
    v1IntegrationArticle3WGetPublishedFromList: (
      query?: { publishedDate?: string; userPpid?: string },
      params: RequestParams = {}
    ) =>
      this.request<Article3WReadDTO[], any>({
        path: `/api/v1/Integration/Article3W/GetPublishedFrom`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name V1DashboardCreate
     * @summary Get all information regarding the news main page.
     * @request POST:/api/v1/Dashboard
     * @secure
     */
    v1DashboardCreate: (data: DashboardFilter, params: RequestParams = {}) =>
      this.request<DashboardDTO, any>({
        path: `/api/v1/Dashboard`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentType
     * @name V1DocumentTypeDetail
     * @summary Return the specified document type.
     * @request GET:/api/v1/DocumentType/{id}
     * @secure
     */
    v1DocumentTypeDetail: (id: string, params: RequestParams = {}) =>
      this.request<DocumentTypeReadDTO, any>({
        path: `/api/v1/DocumentType/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentType
     * @name V1DocumentTypeUpdate
     * @summary Replace the document type.
     * @request PUT:/api/v1/DocumentType/{id}
     * @secure
     */
    v1DocumentTypeUpdate: (id: string, data: DocumentTypeUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/DocumentType/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentType
     * @name V1DocumentTypeDelete
     * @summary Delete the document type.
     * @request DELETE:/api/v1/DocumentType/{id}
     * @secure
     */
    v1DocumentTypeDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/DocumentType/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentType
     * @name V1DocumentTypeList
     * @summary Return all the document types.
     * @request GET:/api/v1/DocumentType
     * @secure
     */
    v1DocumentTypeList: (params: RequestParams = {}) =>
      this.request<DocumentTypeReadDTO[], any>({
        path: `/api/v1/DocumentType`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentType
     * @name V1DocumentTypeCreate
     * @summary Create the specified document type.
     * @request POST:/api/v1/DocumentType
     * @secure
     */
    v1DocumentTypeCreate: (data: DocumentTypeCreateDTO, params: RequestParams = {}) =>
      this.request<DocumentTypeReadDTO, any>({
        path: `/api/v1/DocumentType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentTypeIntegration
     * @name IntegrationDocumentType
     * @summary Return all the document types.
     * @request GET:/api/v1/Integration/DocumentType
     * @secure
     */
    integrationDocumentType: (params: RequestParams = {}) =>
      this.request<DocumentTypeReadDTO[], any>({
        path: `/api/v1/Integration/DocumentType`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event
     * @name V1EventPagedCreate
     * @summary Return all filtered events in a paged result.
     * @request POST:/api/v1/Event/paged
     * @secure
     */
    v1EventPagedCreate: (
      query: { pageNumber: number; pageSize: number },
      data: AmdsEventQueryDTO,
      params: RequestParams = {}
    ) =>
      this.request<AmdsEventReadDTO[], any>({
        path: `/api/v1/Event/paged`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event
     * @name V1EventDetail
     * @summary Return the specified event.
     * @request GET:/api/v1/Event/{id}
     * @secure
     */
    v1EventDetail: (id: string, params: RequestParams = {}) =>
      this.request<AmdsEventReadDTO, any>({
        path: `/api/v1/Event/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event
     * @name V1EventUpdate
     * @summary Update the specified event.
     * @request PUT:/api/v1/Event/{id}
     * @secure
     */
    v1EventUpdate: (id: string, data: AmdsEventUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Event/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event
     * @name V1EventDelete
     * @summary Delete the specified event.
     * @request DELETE:/api/v1/Event/{id}
     * @secure
     */
    v1EventDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Event/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event
     * @name V1EventCreate
     * @summary Create the specified event.
     * @request POST:/api/v1/Event
     * @secure
     */
    v1EventCreate: (data: AmdsEventCreateDTO, params: RequestParams = {}) =>
      this.request<AmdsEventReadDTO, any>({
        path: `/api/v1/Event`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Event
     * @name V1EventPublishPartialUpdate
     * @summary Update the publish state of the event.
     * @request PATCH:/api/v1/Event/{id}/publish
     * @secure
     */
    v1EventPublishPartialUpdate: (id: string, data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Event/${id}/publish`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportAllWordCreate
     * @summary Export articles and news correspondings to filters.
     * @request POST:/api/v1/Export/all/word
     * @secure
     */
    v1ExportAllWordCreate: (data: ExportFilter, query?: { showRating?: boolean }, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/all/word`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportAllExcelCreate
     * @summary Export articles and news correspondings to filters.
     * @request POST:/api/v1/Export/all/excel
     * @secure
     */
    v1ExportAllExcelCreate: (data: ExportFilter, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/all/excel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportArticleExcelCreate
     * @summary Export articles correspondings to ids.
     * @request POST:/api/v1/Export/article/excel
     * @secure
     */
    v1ExportArticleExcelCreate: (data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/article/excel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportNewsSelectedExcelCreate
     * @summary Export news correspondings to ids.
     * @request POST:/api/v1/Export/news/selected/excel
     * @secure
     */
    v1ExportNewsSelectedExcelCreate: (data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/news/selected/excel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportNewsFilteredExcelCreate
     * @summary Export news correspondings to filters.
     * @request POST:/api/v1/Export/news/filtered/excel
     * @secure
     */
    v1ExportNewsFilteredExcelCreate: (data: NewsFilter, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/news/filtered/excel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportEventSelectedExcelCreate
     * @summary Export news correspondings to ids.
     * @request POST:/api/v1/Export/event/selected/excel
     * @secure
     */
    v1ExportEventSelectedExcelCreate: (data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/event/selected/excel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportEventFilteredExcelCreate
     * @summary Export news correspondings to filters.
     * @request POST:/api/v1/Export/event/filtered/excel
     * @secure
     */
    v1ExportEventFilteredExcelCreate: (data: AmdsEventFilter, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/event/filtered/excel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportStatExcelCreate
     * @summary Export statistics.
     * @request POST:/api/v1/Export/stat/excel
     * @secure
     */
    v1ExportStatExcelCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/stat/excel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name V1ExportRightExcelCreate
     * @summary Export statistics.
     * @request POST:/api/v1/Export/right/excel/{type}
     * @secure
     */
    v1ExportRightExcelCreate: (type: Type3W, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Export/right/excel/${type}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issuer
     * @name V1IssuerList
     * @summary Return all issuers.
     * @request GET:/api/v1/Issuer
     * @secure
     */
    v1IssuerList: (params: RequestParams = {}) =>
      this.request<IssuerReadDTO[], any>({
        path: `/api/v1/Issuer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issuer
     * @name V1IssuerCreate
     * @summary Create the specified document type.
     * @request POST:/api/v1/Issuer
     * @secure
     */
    v1IssuerCreate: (data: IssuerCreateDTO, params: RequestParams = {}) =>
      this.request<IssuerReadDTO, any>({
        path: `/api/v1/Issuer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issuer
     * @name V1IssuerDetail
     * @summary Return the specified document type.
     * @request GET:/api/v1/Issuer/{id}
     * @secure
     */
    v1IssuerDetail: (id: string, params: RequestParams = {}) =>
      this.request<IssuerReadDTO, any>({
        path: `/api/v1/Issuer/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issuer
     * @name V1IssuerUpdate
     * @summary Replace the document type.
     * @request PUT:/api/v1/Issuer/{id}
     * @secure
     */
    v1IssuerUpdate: (id: string, data: IssuerUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Issuer/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issuer
     * @name V1IssuerDelete
     * @summary Delete the document type.
     * @request DELETE:/api/v1/Issuer/{id}
     * @secure
     */
    v1IssuerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Issuer/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags IssuerIntegration
     * @name IntegrationIssuer
     * @summary Return all issuers.
     * @request GET:/api/v1/Integration/Issuer
     * @secure
     */
    integrationIssuer: (params: RequestParams = {}) =>
      this.request<IssuerReadDTO[], any>({
        path: `/api/v1/Integration/Issuer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name V1MetadataTypesList
     * @summary Return all 3W types decode.
     * @request GET:/api/v1/Metadata/types
     * @secure
     */
    v1MetadataTypesList: (params: RequestParams = {}) =>
      this.request<TypeAccesses, any>({
        path: `/api/v1/Metadata/types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name V1MetadataUsedDetail
     * @summary Return all metadata used.
     * @request GET:/api/v1/Metadata/used/{type}
     * @secure
     */
    v1MetadataUsedDetail: (type: Type3W, params: RequestParams = {}) =>
      this.request<MetadataDTO, any>({
        path: `/api/v1/Metadata/used/${type}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsPagedCreate
     * @summary Return all filtered news in a paged result.
     * @request POST:/api/v1/News/paged
     * @secure
     */
    v1NewsPagedCreate: (
      query: { pageNumber: number; pageSize: number },
      data: NewsQueryDTO,
      params: RequestParams = {}
    ) =>
      this.request<NewsReadDTO[], any>({
        path: `/api/v1/News/paged`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsDetail
     * @summary Return the specified news.
     * @request GET:/api/v1/News/{id}
     * @secure
     */
    v1NewsDetail: (id: string, params: RequestParams = {}) =>
      this.request<NewsReadDTO, any>({
        path: `/api/v1/News/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsUpdate
     * @summary Update the specified news.
     * @request PUT:/api/v1/News/{id}
     * @secure
     */
    v1NewsUpdate: (id: string, data: NewsUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsDelete
     * @summary Delete the specified news.
     * @request DELETE:/api/v1/News/{id}
     * @secure
     */
    v1NewsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsByArticleDetail
     * @summary Return the news associated with the specified article.
     * @request GET:/api/v1/News/byArticle/{articleId}
     * @secure
     */
    v1NewsByArticleDetail: (articleId: string, params: RequestParams = {}) =>
      this.request<NewsReadDTO[], any>({
        path: `/api/v1/News/byArticle/${articleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsTitlesCreate
     * @summary Return the specified titles of news list.
     * @request POST:/api/v1/News/titles
     * @secure
     */
    v1NewsTitlesCreate: (data: string[], params: RequestParams = {}) =>
      this.request<NewsTitleReadDTO[], any>({
        path: `/api/v1/News/titles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsCreate
     * @summary Create the specified news.
     * @request POST:/api/v1/News
     * @secure
     */
    v1NewsCreate: (data: NewsCreateDTO, params: RequestParams = {}) =>
      this.request<NewsReadDTO, any>({
        path: `/api/v1/News`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsImportList
     * @summary Download the template for the import.
     * @request GET:/api/v1/News/import
     * @secure
     */
    v1NewsImportList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/import`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsImportCreate
     * @summary Import news from Excel file.
     * @request POST:/api/v1/News/import
     * @secure
     */
    v1NewsImportCreate: (data: { importFile?: File }, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsPublishedPartialUpdate
     * @summary Update the published state of the news.
     * @request PATCH:/api/v1/News/{id}/published
     * @secure
     */
    v1NewsPublishedPartialUpdate: (id: string, data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/${id}/published`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsMustReadPartialUpdate
     * @summary Update the must read state of the news.
     * @request PATCH:/api/v1/News/{id}/MustRead
     * @secure
     */
    v1NewsMustReadPartialUpdate: (id: string, data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/${id}/MustRead`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsArticleIdPartialUpdate
     * @summary Update the article id of the news.
     * @request PATCH:/api/v1/News/ArticleId
     * @secure
     */
    v1NewsArticleIdPartialUpdate: (data: NewsUpdateArticleIdDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/ArticleId`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags News
     * @name V1NewsIsAlivePartialUpdate
     * @summary Check if one news is alive.
     * @request PATCH:/api/v1/News/{id}/IsAlive
     * @secure
     */
    v1NewsIsAlivePartialUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/News/${id}/IsAlive`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags NewsIntegration
     * @name V1IntegrationNewsGetPublishedFromList
     * @summary Return the news with a publication date equal or greater than the one specified.
     * @request GET:/api/v1/Integration/News/GetPublishedFrom
     * @secure
     */
    v1IntegrationNewsGetPublishedFromList: (
      query?: { publishedDate?: string; userPpid?: string },
      params: RequestParams = {}
    ) =>
      this.request<NewsReadDTO[], any>({
        path: `/api/v1/Integration/News/GetPublishedFrom`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationPagedCreate
     * @summary Return all filtered publications in a paged result.
     * @request POST:/api/v1/Publication/paged
     * @secure
     */
    v1PublicationPagedCreate: (
      query: { pageNumber: number; pageSize: number },
      data: PublicationQueryDTO,
      params: RequestParams = {}
    ) =>
      this.request<PublicationReadDTO[], any>({
        path: `/api/v1/Publication/paged`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationDetail
     * @summary Return the specified publication.
     * @request GET:/api/v1/Publication/{id}
     * @secure
     */
    v1PublicationDetail: (id: string, params: RequestParams = {}) =>
      this.request<PublicationReadDTO, any>({
        path: `/api/v1/Publication/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationUpdate
     * @summary Update the specified publication.
     * @request PUT:/api/v1/Publication/{id}
     * @secure
     */
    v1PublicationUpdate: (
      id: string,
      data: {
        Title?: string;
        Description?: string;
        TerritoryId?: string;
        IssueDate?: string;
        IssuerIds?: string[];
        TopicIds?: string[];
        File?: File;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v1/Publication/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationDelete
     * @summary Delete the specified publication.
     * @request DELETE:/api/v1/Publication/{id}
     * @secure
     */
    v1PublicationDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Publication/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationFileDetail
     * @summary Return the specified publication file.
     * @request GET:/api/v1/Publication/{id}/file/{fileId}
     * @secure
     */
    v1PublicationFileDetail: (id: string, fileId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Publication/${id}/file/${fileId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationCreate
     * @summary Create the specified publication.
     * @request POST:/api/v1/Publication
     * @secure
     */
    v1PublicationCreate: (
      data: {
        Published?: boolean;
        Type?: Type3W;
        Title?: string;
        Description?: string;
        File?: File;
        IssueDate?: string;
        TerritoryId?: string;
        IssuerIds?: string[];
        TopicIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PublicationReadDTO, any>({
        path: `/api/v1/Publication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Publication
     * @name V1PublicationPublishPartialUpdate
     * @summary Update the publish state of the publication.
     * @request PATCH:/api/v1/Publication/{id}/publish
     * @secure
     */
    v1PublicationPublishPartialUpdate: (id: string, data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Publication/${id}/publish`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags RSS
     * @name V1RssList
     * @request GET:/api/v1/RSS
     * @secure
     */
    v1RssList: (query?: { type3W?: Type3W; startItem?: number; nbItems?: number }, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/RSS`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubscriptionAccess
     * @name V1SubscriptionAccessDetail
     * @summary Return the specified subscription access.
     * @request GET:/api/v1/SubscriptionAccess/{subscriptionId}
     * @secure
     */
    v1SubscriptionAccessDetail: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<SubscriptionAccessReadDTO, any>({
        path: `/api/v1/SubscriptionAccess/${subscriptionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubscriptionAccess
     * @name V1SubscriptionAccessUpdate
     * @summary Create or update the subscription access.
     * @request PUT:/api/v1/SubscriptionAccess/{subscriptionId}
     * @secure
     */
    v1SubscriptionAccessUpdate: (
      subscriptionId: string,
      data: SubscriptionAccessUpdateDTO,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/v1/SubscriptionAccess/${subscriptionId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubscriptionAccess
     * @name V1SubscriptionAccessDetail2
     * @summary Return all subscription access available for the 3W type.
     * @request GET:/api/v1/SubscriptionAccess/{type}
     * @originalName v1SubscriptionAccessDetail
     * @duplicate
     * @secure
     */
    v1SubscriptionAccessDetail2: (type: Type3W, params: RequestParams = {}) =>
      this.request<SubscriptionAccessLightReadDTO[], any>({
        path: `/api/v1/SubscriptionAccess/${type}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Territory
     * @name V1TerritoryList
     * @summary Return territories.
     * @request GET:/api/v1/Territory
     * @secure
     */
    v1TerritoryList: (params: RequestParams = {}) =>
      this.request<TerritoryReadDTO[], any>({
        path: `/api/v1/Territory`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TerritoryIntegration
     * @name IntegrationTerritory
     * @summary Return territories.
     * @request GET:/api/v1/Integration/Territory
     * @secure
     */
    integrationTerritory: (params: RequestParams = {}) =>
      this.request<TerritoryReadDTO[], any>({
        path: `/api/v1/Integration/Territory`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topic
     * @name V1TopicDetail
     * @summary Return the specified topic.
     * @request GET:/api/v1/Topic/{id}
     * @secure
     */
    v1TopicDetail: (id: string, params: RequestParams = {}) =>
      this.request<TopicReadDTO, any>({
        path: `/api/v1/Topic/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topic
     * @name V1TopicUpdate
     * @summary Replace the topic.
     * @request PUT:/api/v1/Topic/{id}
     * @secure
     */
    v1TopicUpdate: (id: string, data: TopicUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Topic/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topic
     * @name V1TopicDelete
     * @summary Delete the topic.
     * @request DELETE:/api/v1/Topic/{id}
     * @secure
     */
    v1TopicDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Topic/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topic
     * @name V1TopicList
     * @summary Return all the topics.
     * @request GET:/api/v1/Topic
     * @secure
     */
    v1TopicList: (params: RequestParams = {}) =>
      this.request<TopicReadDTO[], any>({
        path: `/api/v1/Topic`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topic
     * @name V1TopicCreate
     * @summary Create the specified topic.
     * @request POST:/api/v1/Topic
     * @secure
     */
    v1TopicCreate: (data: TopicCreateDTO, params: RequestParams = {}) =>
      this.request<TopicReadDTO, any>({
        path: `/api/v1/Topic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TopicIntegration
     * @name IntegrationTopic
     * @summary Return all the topics.
     * @request GET:/api/v1/Integration/Topic
     * @secure
     */
    integrationTopic: (params: RequestParams = {}) =>
      this.request<TopicReadDTO[], any>({
        path: `/api/v1/Integration/Topic`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoPagedCreate
     * @summary Return all filtered videos in a paged result.
     * @request POST:/api/v1/Video/paged
     * @secure
     */
    v1VideoPagedCreate: (
      query: { pageNumber: number; pageSize: number },
      data: VideoQueryDTO,
      params: RequestParams = {}
    ) =>
      this.request<VideoReadDTO[], any>({
        path: `/api/v1/Video/paged`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoDetail
     * @summary Return the specified video.
     * @request GET:/api/v1/Video/{id}
     * @secure
     */
    v1VideoDetail: (id: string, params: RequestParams = {}) =>
      this.request<VideoReadDTO, any>({
        path: `/api/v1/Video/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoUpdate
     * @summary Update the specified video.
     * @request PUT:/api/v1/Video/{id}
     * @secure
     */
    v1VideoUpdate: (id: string, data: VideoUpdateDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Video/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoDelete
     * @summary Delete the specified video.
     * @request DELETE:/api/v1/Video/{id}
     * @secure
     */
    v1VideoDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Video/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoCreate
     * @summary Create the specified video.
     * @request POST:/api/v1/Video
     * @secure
     */
    v1VideoCreate: (data: VideoCreateDTO, params: RequestParams = {}) =>
      this.request<VideoReadDTO, any>({
        path: `/api/v1/Video`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoPublishPartialUpdate
     * @summary Update the publish state of the video.
     * @request PATCH:/api/v1/Video/{id}/publish
     * @secure
     */
    v1VideoPublishPartialUpdate: (id: string, data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Video/${id}/publish`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
